<template>
  <a-config-provider :locale="idID">
    <div id="app" v-if="!getIsPublic">
      <Preloader />
      <a-layout class="main-layout" v-if="!getScreen">
        <Mis-Navigation v-if="initialLogin" />
        <a-layout :style="{ marginLeft: '320px' }">
          <a-layout-content class="content-layout">
            <router-view />
          </a-layout-content>
        </a-layout>
      </a-layout>
      <a-layout v-else-if="getScreen" class="m-layout">
        <a-affix :offsetTop="this.top">
          <Mis-Header v-if="initialLogin" />
        </a-affix>
        <a-layout-content class="m-content">
          <router-view />
        </a-layout-content>
      </a-layout>
      <Mis-Notification :visible="getNotificationView" />
    </div>
    <div id="app" v-else>
      <a-layout :class="!getScreen ? 'main-layout' : 'm-layout'">
        <a-layout>
          <transition name="fade">
            <router-view />
          </transition>
        </a-layout>
      </a-layout>
    </div>
  </a-config-provider>
</template>

<script>
import { mapGetters } from "vuex";
import idID from "ant-design-vue/lib/locale-provider/id_ID";
import ScreenMixins from "@/mixins/ScreenCheckMixins.js";
import versioning from "@/mixins/Versioning.js";
import moment from "moment";
import Preloader from "@/components/preloader/PageLoading.vue";
import "moment/locale/id";

moment.locale("id");
export default {
  name: "app",
  components: {
    Preloader,
  },
  data() {
    return {
      idID,
      top: 0,
      interval: 0,
    };
  },
  computed: {
    ...mapGetters([
      "getScreen",
      "getAuth",
      "getIsLogin",
      "getIsPublic",
      "getNotificationView",
      "appVersion",
    ]),
    initialLogin() {
      return this.getIsLogin;
    },
    initialVersion() {
      return this.setNextVersion("0.1.1-alpha");
    },
  },
  methods: {
    handleNotification() {
      this.$store.dispatch("SET_NOTIFICATION_VIEW");
    },
    closeNotification(value) {
      this.$store.dispatch("CLOSE_NOTIFICATION_VIEW", value);
    },
  },
  created() {
    setInterval(() => {
      if (!this.getIsPublic) {
        this.$store.dispatch("FETCH_NOTIFICATION");
      }
    }, 600000);
  },
  mounted() {
    if (!this.getIsPublic) {
      this.$store.dispatch("Fetch_Bank");
      this.$store.dispatch("Fetch_Satuan");
      this.$store.dispatch("FETCH_ALL_BOD");
      this.$store.dispatch("FETCH_ATASAN");
      this.$store.dispatch("FETCH_ALL_GUDANG");
      this.$store.dispatch("FETCH_NOTIFICATION");
    }
    Event.$on("notificationToggle", this.handleNotification);
    Event.$on("closeNotification", this.closeNotification);
  },
  mixins: [ScreenMixins, versioning],
};
</script>

<style scoped lang="less">
.m {
  &-layout {
    min-height: 100vh;
  }
  &-content {
    margin-top: 15px;
    min-height: 280px;
    padding: 0 @padding;
  }
}

.main-layout {
  min-height: 100vh !important;

  .trigger-collapse {
    font-size: 18px;
    line-height: 64px;
    padding: 0 24px;
    cursor: pointer;
    transition: color 0.3s;
  }
}

.content-layout {
  padding: @padding;
  min-height: 280px;
}

.header-layout {
  padding: 0;
  background-color: white;
  box-shadow: 0 2px 8px #f0f1f2;
}

.fade {
  &-enter-active,
  &-leave-active {
    transition: opacity 0.25s ease-out;
  }

  &-enter,
  &-leave-to {
    opacity: 0;
  }
}
</style>
